type FbqFn = (...args: unknown[]) => void;
interface FbqWindow extends Window {
  fbq?: FbqFn;
  metaPixelId?: string;
}

// eventID must be fbq's 4th argument: Meta pairs it with the CAPI event_id so the two count as one.
// userData re-inits advanced matching, which fbevents only accepts while the pixel has no user data yet.
export function trackFbEvent(
  event: string,
  eventId: string,
  customData: Record<string, unknown> = {},
  userData?: Record<string, string | undefined>
): void {
  const { fbq, metaPixelId } = window as FbqWindow;
  if (!fbq) return;

  if (userData && metaPixelId) {
    fbq(
      'init',
      metaPixelId,
      Object.fromEntries(Object.entries(userData).filter(([, value]) => value))
    );
  }
  fbq('track', event, customData, { eventID: eventId });
}
